import styled from 'styled-components';
var ExternalLinkStyles = styled.a.withConfig({
  displayName: "ExternalLinkstyles__ExternalLinkStyles",
  componentId: "pantheon__sc-1spit53-0"
})(["text-decoration:none;font-weight:700;color:#454545;"]);
export { ExternalLinkStyles };